@use 'src/global/variables.scss' as var;
@use 'src/global/mixins/icon.scss' as icon;
@use 'src/global/mixins/link.scss' as link;
@use 'src/global/mixins/feedback.scss' as fb;

c-bubble-info {
  display: block;
  width: 100%;
  height: 100%;
  hyphens: none;
  -webkit-hyphens: none;

  .bubble-container-with-feedback {
    @include fb.bubble-container-with-feedback;
  }

  section {
    padding: 1rem;
    box-shadow: var.$message-screen-elements-box-shadow;
    box-sizing: border-box;
    border-radius: var.$bubble-border-radius;
    background: var.$primary-color;
    color: var.$text-color-light;

    a {
      @include link.link;
    }

    .info-container {
      margin-top: 1rem;
      display: flex;
      .info-icon {
        min-width: 1.5rem;
        margin-right: 0.8rem;
        &:before {
          font-size: 1.5rem;
          @include icon.icon;
          color: var.$text-color-light;
          content: '\f143';
        }
      }
      .info-text {
        font-style: italic;
      }
    }
  }
}
